import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';
import { localOf } from '@/lib/companyTime';

/**
 * Ligne d'une feuille d'heures (GET / POST / PATCH / DELETE /time_entries) : une plage horaire d'un jour, modifiable
 * tant que la feuille est en brouillon. startAt / endAt : instants UTC (ISO 8601), lus et saisis en date + heures à
 * l'heure de la société (localIn, lib/companyTime) ; durationMinutes calculée par l'API. Règles de l'API (422) : fin
 * après le début, le même jour, plage terminée, pas de chevauchement avec une autre ligne de l'employé. Filtre :
 * timeSheet ; tri startAt.
 */
export default class TimeEntryModel extends AbstractApiModel {
  protected _path = '/time_entries/{?id}';

  declare _tsFilters: { timeSheet?: string };
  declare _tsSorts: { startAt?: unknown };

  @doc.string declare startAt: string;
  @doc.string declare endAt: string;
  /** Projet (client, projet ou n° de ticket), commentaire : facultatifs, texte libre ('' sans valeur) */
  @doc.string declare project: string;
  @doc.string declare comment: string;
  @doc.number declare durationMinutes: number;

  /** Jour (« 2026-10-05 ») et heures (« 18:00 ») de la plage à l'heure de la société */
  localIn(timezone: string): { day: string; startTime: string; endTime: string } {
    const start = localOf(this.startAt, timezone);
    return { day: start.date, startTime: start.time, endTime: localOf(this.endAt, timezone).time };
  }
}
